import React, { Component } from 'react';
import {connect} from "react-redux";

import {
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem} from 'reactstrap';






class NavBar extends Component {


    constructor(props) {
        super(props);



        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.logOut = this.logOut.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    logOut(){
        localStorage.clear();
        window.location.reload();
    }


    render() {

        if (this.props.state.loggedIn === false){
            return (<div></div>);
        }
        else {

            let communicate = '';
            if (window.location.hash === '#/communicate') {
                communicate = <NavLink className="activeTab" href="#/communicate">Communicate</NavLink>;
            } else {
                communicate = <NavLink href="#/communicate">Communicate</NavLink>;
            }

            let register = '';
            if (window.location.hash === '#/register') {
                register = <NavLink className="activeTab" href="#/register">Register</NavLink>;
            } else {
                register = <NavLink href="#/register">Register</NavLink>;
            }

            let roundRobin = '';
            if (window.location.hash === '#/') {
                roundRobin = <NavLink className="activeTab" href="#/">Round Robin</NavLink>;
            } else {
                roundRobin = <NavLink href="#/">Round Robin</NavLink>;
            }

            let emailsPage = '';
            if (window.location.hash === '#/stats') {
                emailsPage = <NavLink className="activeTab" href="#/stats">Stats</NavLink>;
            } else {
                emailsPage = <NavLink href="#/stats">Stats</NavLink>;
            }

            let reportsPage = '';
            if (window.location.hash === '#/reports') {
                reportsPage = <NavLink className="activeTab" href="#/reports">Reports</NavLink>;
            } else {
                reportsPage = <NavLink href="#/reports">Reports</NavLink>;
            }

            let testUserPage = '';
            if (window.location.hash === '#/testusers') {
                testUserPage = <NavLink className="activeTab" href="#/testusers">Test Users</NavLink>;
            } else {
                testUserPage = <NavLink href="#/testusers">Test Users</NavLink>;
            }

            let incentivesPage = '';
            if (window.location.hash === '#/incentives') {
                incentivesPage = <NavLink className="activeTab" href="#/incentives">Incentives</NavLink>;
            } else {
                incentivesPage = <NavLink href="#/incentives">Incentives</NavLink>;
            }


            if (this.props.state.user.permission === 'admin') {
                return (
                    <div>
                        <Navbar color="faded" light expand="md" className="navbar">
                            <div className="container">
                                <NavLink href="#/">
                                    <div className="logo-square">
                                        ION
                                    </div>
                                </NavLink>

                                <NavbarToggler onClick={this.toggleNavbar} className="mr-2"/>
                                <Collapse isOpen={!this.state.collapsed} navbar>
                                    <Nav className="ml-auto" navbar>
                                        <NavItem>
                                            {roundRobin}
                                        </NavItem>
                                        <NavItem>
                                            {emailsPage}
                                        </NavItem>
                                        <NavItem>
                                            {reportsPage}
                                        </NavItem>
                                        <NavItem>
                                            {communicate}
                                        </NavItem>
                                        <NavItem>
                                            {register}
                                        </NavItem>
                                        <NavItem>
                                            {incentivesPage}
                                        </NavItem>
                                        <NavItem>
                                            {testUserPage}
                                        </NavItem>
                                        <UncontrolledDropdown nav>
                                            <DropdownToggle nav caret>
                                                {this.props.state.user.first_name}
                                            </DropdownToggle>
                                            <DropdownMenu >
                                                <DropdownItem onClick={this.logOut}>
                                                    Log Out
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </Nav>
                                </Collapse>
                            </div>
                        </Navbar>
                    </div>
                );
            } else if (this.props.state.user.permission === 'manager') {
                return (
                    <div>
                        <Navbar color="faded" expand="md" className="navbar">
                            <div className="container">
                                <NavLink href="#/">
                                    <div className="logo-square">
                                        ION
                                    </div>
                                </NavLink>

                                <NavbarToggler onClick={this.toggleNavbar} className="mr-2"/>
                                <Collapse isOpen={!this.state.collapsed} navbar>
                                    <Nav className="ml-auto" navbar>
                                        <UncontrolledDropdown nav>
                                            <DropdownToggle nav caret>
                                                {this.props.state.user.first_name}
                                            </DropdownToggle>
                                            <DropdownMenu >
                                                <DropdownItem onClick={this.logOut}>
                                                    Log Out
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </Nav>
                                </Collapse>
                            </div>
                        </Navbar>
                    </div>
                );
            }
        }
    }



}


function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(NavBar);


// WEBPACK FOOTER //
// ./src/components/shared/NavBar.js